import React from 'react'
import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink, SidebarItem, SidebarDropdownContent, SidebarDropdown} from './SidebarElements'



const Sidebar = ({ isOpen, toggle }) => {

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
            <CloseIcon />
        </Icon>
        <SidebarWrapper>
            <SidebarMenu>
                    <SidebarLink to="about" smooth={true} onClick={toggle}>ABOUT</SidebarLink>
                    <SidebarItem>
                        <SidebarLink>
                            <SidebarDropdown>
                                <SidebarLink>MATERI</SidebarLink>
                                <SidebarDropdownContent>
                                    <SidebarLink to="materiA" smooth={true} offset={-70} onClick={toggle}>AED-A</SidebarLink>
                                    <SidebarLink to="materiB" smooth={true} offset={-70} onClick={toggle}>AED-B</SidebarLink>
                                    <SidebarLink to="materiC" smooth={true} offset={-70} onClick={toggle}>AED-C</SidebarLink>
                                    <SidebarLink to="materiD" smooth={true} offset={-70} onClick={toggle}>AED-D</SidebarLink>
                                    <SidebarLink to="materiIUP" smooth={true} offset={-70} onClick={toggle}>AED-IUP</SidebarLink>
                                </SidebarDropdownContent>
                            </SidebarDropdown>
                        </SidebarLink>   
                    </SidebarItem>
                    {/* <SidebarLink to="tugas" smooth={true} onClick={toggle}>TUGAS</SidebarLink> */}
                    <SidebarLink to="contact" smooth={true} onClick={toggle}>CONTACT</SidebarLink>
            </SidebarMenu>
        </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar